const SESSION_MEMORY_KEYS = Object.freeze({
  customer: "customer",
  whitelabel: "whitelabel",
});

const sessionMemory = {
  [SESSION_MEMORY_KEYS.customer]: null,
  [SESSION_MEMORY_KEYS.whitelabel]: null,
};

const listeners = new Set();

function notifyListeners() {
  listeners.forEach((listener) => {
    try {
      listener({ ...sessionMemory });
    } catch (_) {
      // ignore listener errors to avoid breaking state updates
    }
  });
}

function parseIfString(value) {
  if (typeof value !== "string") return value;
  try {
    return JSON.parse(value);
  } catch (_) {
    return null;
  }
}

function setMemoryValue(key, value) {
  sessionMemory[key] = parseIfString(value);
  notifyListeners();
}

export function subscribeSessionMemory(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getCustomerFromMemory() {
  return sessionMemory[SESSION_MEMORY_KEYS.customer];
}

export function setCustomerInMemory(value) {
  setMemoryValue(SESSION_MEMORY_KEYS.customer, value);
}

export function removeCustomerFromMemory() {
  sessionMemory[SESSION_MEMORY_KEYS.customer] = null;
  notifyListeners();
}

export function getWhitelabelFromMemory() {
  return sessionMemory[SESSION_MEMORY_KEYS.whitelabel];
}

export function setWhitelabelInMemory(value) {
  setMemoryValue(SESSION_MEMORY_KEYS.whitelabel, value);
}

export function removeWhitelabelFromMemory() {
  sessionMemory[SESSION_MEMORY_KEYS.whitelabel] = null;
  notifyListeners();
}

export function hydrateSessionMemory({ customer, whitelabel } = {}) {
  if (customer !== undefined) {
    sessionMemory[SESSION_MEMORY_KEYS.customer] = parseIfString(customer);
  }
  if (whitelabel !== undefined) {
    sessionMemory[SESSION_MEMORY_KEYS.whitelabel] = parseIfString(whitelabel);
  }
  notifyListeners();
}
